"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStyles = void 0;
var styles_1 = require("../../../../styles");
exports.createStyles = function (theme) { return ({
    button: {
        backgroundColor: 'transparent',
        border: '1px solid transparent',
        borderRadius: theme.radius.button,
        color: theme.pallete.text.main,
        textDecoration: 'none',
        ':not(:disabled):active': {
            boxShadow: 'inset 0 2px 8px 0 rgba(0, 0, 0, 0.1)',
        },
        ':focus': {
            outline: 'none',
            boxShadow: styles_1.focusBoxShadow(theme, 'primary', 'single'),
        },
        ':not(:disabled):hover': {
            backgroundColor: styles_1.hexToRGB(theme.pallete.gray.c20, 0.1),
        },
    },
    primary: {
        color: theme.pallete.primary.main,
    },
    danger: {
        color: theme.pallete.status.danger.main,
        ':focus': {
            boxShadow: styles_1.focusBoxShadow(theme, 'danger'),
        },
    },
}); };
//# sourceMappingURL=ghost.js.map